import React from "react";
import SitePageLayout from "../components/SitePageLayout";

const sections = [
  {
    id: "responsable",
    title: "1. Responsable del tratamiento",
    paragraphs: [
      "Apedir es responsable del tratamiento de los datos personales que se recopilen a traves de esta web y de los canales de soporte relacionados con la app.",
      "Para solicitudes de privacidad o soporte puedes escribir a contacto@apedir.com o usar la pagina de contacto disponible en /contacto.",
    ],
  },
  {
    id: "datos-que-recopilamos",
    title: "2. Datos que podemos recopilar",
    paragraphs: [
      "Podemos recopilar datos que entregas directamente, como nombre, correo, telefono, nombre del negocio, asunto y mensajes enviados mediante formularios.",
      "Si utilizas funciones de pedidos o cuentas dentro de la app, tambien podemos tratar datos operativos necesarios para prestar el servicio, como informacion de cuenta, direccion de entrega, historial de pedidos o incidencias de soporte.",
      "Adicionalmente, el servidor puede registrar informacion tecnica basica, como direccion IP, fecha, hora y errores de acceso, con fines de seguridad y operacion.",
    ],
  },
  {
    id: "uso-de-la-informacion",
    title: "3. Como usamos la informacion",
    paragraphs: [
      "Usamos la informacion para responder solicitudes, prestar soporte, gestionar registros, operar la plataforma, mejorar la calidad del servicio y cumplir obligaciones legales o de seguridad.",
      "No usamos los datos para finalidades incompatibles con el motivo por el cual fueron entregados.",
    ],
  },
  {
    id: "comparticion",
    title: "4. Cuando compartimos datos",
    paragraphs: [
      "No vendemos datos personales. Solo podemos compartir informacion con proveedores tecnologicos o aliados operativos cuando sea necesario para alojar la plataforma, dar soporte tecnico o cumplir obligaciones legales.",
      "Si una autoridad competente lo exige, podremos revelar la informacion estrictamente necesaria conforme a la ley aplicable.",
    ],
  },
  {
    id: "conservacion",
    title: "5. Tiempo de conservacion",
    paragraphs: [
      "Conservamos los datos durante el tiempo necesario para atender tu solicitud, operar el servicio, resolver disputas, proteger la seguridad de la plataforma y cumplir obligaciones legales o contractuales.",
    ],
  },
  {
    id: "seguridad",
    title: "6. Seguridad de la informacion",
    paragraphs: [
      "Aplicamos medidas razonables de seguridad tecnicas y organizativas para proteger la informacion frente a accesos no autorizados, perdida, alteracion o divulgacion indebida.",
      "Ningun sistema es completamente infalible, por lo que te recomendamos no compartir informacion innecesaria o sensible a traves de formularios abiertos.",
    ],
  },
  {
    id: "derechos",
    title: "7. Tus derechos",
    paragraphs: [
      "Puedes solicitar acceso, actualizacion, correccion o eliminacion de tus datos, asi como hacer consultas o reclamos sobre su tratamiento.",
      "Para ejercer estos derechos, escribe a contacto@apedir.com o utiliza la pagina /contacto indicando claramente tu solicitud.",
    ],
  },
  {
    id: "cookies",
    title: "8. Cookies y datos tecnicos",
    paragraphs: [
      "La web puede utilizar elementos tecnicos necesarios para su funcionamiento, como almacenamiento local del navegador, registros de error o recursos de seguridad. Si en el futuro se incorporan cookies analiticas, publicitarias o SDKs adicionales, esta politica debe actualizarse antes de su uso.",
    ],
  },
  {
    id: "uso-del-servicio",
    title: "9. Condiciones basicas de uso",
    paragraphs: [
      "Al usar la web o la app aceptas hacerlo de forma licita, sin afectar la seguridad del servicio ni los derechos de terceros. Apedir puede actualizar funciones, contenidos o procesos cuando sea necesario para operar correctamente la plataforma.",
    ],
  },
  {
    id: "cambios",
    title: "10. Cambios a esta politica",
    paragraphs: [
      "Podemos actualizar esta politica para reflejar cambios operativos, legales o de producto. La version vigente sera siempre la publicada en esta URL.",
      "Ultima actualizacion: 2 de abril de 2026.",
    ],
  },
];

const PrivacyPage = () => {
  return (
    <SitePageLayout
      eyebrow="Legal"
      title="Politica de privacidad"
      description="Esta pagina publica explica de forma general como Apedir recopila, usa, protege y atiende solicitudes relacionadas con datos personales en la web y en la app."
    >
      <div className="space-y-6">
        {sections.map((section) => (
          <article
            key={section.id}
            id={section.id}
            className="neumorphic rounded-3xl p-8"
          >
            <h2 className="text-2xl font-bold tracking-tight">{section.title}</h2>
            <div className="mt-4 space-y-4 text-sm md:text-base leading-relaxed text-muted-foreground">
              {section.paragraphs.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}
            </div>
          </article>
        ))}
      </div>
    </SitePageLayout>
  );
};

export default PrivacyPage;
